<template>
  <a-modal :visible="visible" @ok="process" @cancel="cancel" width="500px" :confirmLoading="loading.confirm"
    :maskClosable="false">
    <span slot="title"> <a-icon type="reconciliation" />&nbsp;Medical Claim Recapitulation Process</span>

    <a-form-model
      ref="formDialog"
      :model="formDialog.form"
      :rules="formDialog.rules"
    >
      <a-form-model-item label="Total Recapitulation (IDR)" prop="total_rekap">
        <a-input-number
          :min="0"
          class="m-width-full m-text-align-right"
          :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
          :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
          @keydown="onlyNumber"
          disabled
          v-model="formDialog.form.total_rekap"
        ></a-input-number>
      </a-form-model-item>
      <a-form-model-item label="Description" prop="description">
        <a-textarea placeholder="Write the note here ... " :rows="4" v-model="formDialog.form.description" :disabled="loading.confirm"/>
      </a-form-model-item>
      <a-form-model-item label="Document Support" prop="document_support">
        <a-upload :fileList="formDialog.fileList" v-model="formDialog.form.document_support" 
          :remove="handleRemove" 
          :beforeUpload="beforeUpload"
          :disabled="loading.confirm"
          >
          <a-button>
            <a-icon type="upload" />Select File
          </a-button>
        </a-upload>
      </a-form-model-item>
    </a-form-model>
    <template slot="footer" class="flex">
      <a-button type="default" class="m-width-full margin-bottom-small" @click="processPreview" :loading="loading.preview">Preview</a-button>
      <a-button type="primary" class="m-width-full margin-remove" @click="process" :loading="loading.confirm">Process Recapitulation</a-button>
    </template>
  </a-modal>
</template>
<script>
import { mapGetters } from "vuex";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";
import axios from "axios";
export default {
  name: "DialogProcess",
  mixins: [GlobalMethod],
  props: ["visible","selectedData"],
  data(){
    let doc_validation = (rule, value, callback) => {
      if (this.formDialog.fileList == null || this.formDialog.fileList.length==0) {
        callback(new Error("Upload File Cannot be Empty!"));
      } else {
        callback();
      }
    };

    return {
      loading: {
        confirm: false,
        preview: false,
      },
      formDialog:{
        form: {
          total_rekap: null,
          description: null,
          document_support: null
        },
        rules: {
          total_rekap: {
            required: true,
            message: "Total Recapitulation is required!",
            trigger: "change",
          },
          description: {
            required: true,
            message: "Description is required!",
            trigger: "change",
          },
          document_support: {
            required: false,
            // validator: doc_validation,
            message: "Document Support is required!",
            trigger: "change",
          },
        },
        fileList:[]
      }
    }
  },
  computed: {
    ...mapGetters(["getScreen", "getAuth"]),
  },
  mounted(){
    this.sumTotalSelected()
  },
  methods:{
    process(){
      this.$refs.formDialog.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }
        let formData = new FormData();
        formData.append("description", this.formDialog.form.description);
        formData.append("total", this.formDialog.form.total_rekap);
        if(this.formDialog.fileList && this.formDialog.fileList.length>0)
          formData.append(`file_support`, this.formDialog.fileList[0]);
        if(this.selectedData.length>0){
          this.selectedData.forEach((element,index) => {
            formData.append(`selected_item[${index}]`, element.id_klaim_kesehatan_hdr);
          });
        }else{
          this.displayMessageValue("error-other", 'No data Selected!');
          return
        }

        this.loading.confirm = true
        this.asyncAxiosPost("rekap_kesehatan",
          "formdata", this.getAuth, formData)
        .then(() => {
          Event.$emit("closeDiagProc");
          Event.$emit("fetchTab");
          this.displayMessage("success-save");
          this.loading.confirm = false
        })
        .catch(() => {
          this.loading.confirm = false
        });
      })
    },
    processPreview(){
      this.$refs.formDialog.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }
        let formData = new FormData();
        formData.append("description", this.formDialog.form.description);
        this.selectedData.forEach((element,index) => {
          formData.append(`selected_item[${index}]`, element.id_klaim_kesehatan_hdr);
        });

        this.loading.preview = true
        axios({
          method: "post",
          url: this.$serviceUrl + "rekap_kesehatan/preview",
          data: formData,
          responseType: "blob",
          processData: false,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.previewLoad = false;
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          this.loading.preview = false
        })
        .catch(() => {
        });
      })
    },
    sumTotalSelected(){
      this.formDialog.form.total_rekap = _.sumBy(this.selectedData, function (val) {
        return val.total_nilai_klaim_appr ? Number(val.total_nilai_klaim_appr) : 0
      });
    },
    cancel(){
      Event.$emit("closeDiagProc");
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 10) {
        this.displayMessage("large-file-10mb");
      } else {
        this.formDialog.fileList = [file];
        return false;
      }
    },
    handleRemove() {
      this.formDialog.fileList = [];
    },
  }
}
</script>
<style lang="less">
.m-text-align-right{
  input{
    text-align: right;
  }
}
</style>